import type { App } from 'vue';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';

// 暗色模式 CSS 变量（亮色模式通过 el-light.scss 在编译时自动注入）
import 'element-plus/theme-chalk/dark/css-vars.css';

// 按需导入全局服务类 API（这些无法通过 auto-import 自动导入组件形式）
import {
  ElMessage,
  ElMessageBox,
  ElNotification,
  ElLoading
} from 'element-plus';

/**
 * Element Plus 插件配置（按需导入模式）
 *
 * 说明：
 * 1. 组件（ElButton, ElTable, ElInput 等）通过 unplugin-vue-components 自动按需导入
 * 2. 图标通过这里全局注册，方便在模板中直接使用 <el-icon><User /></el-icon>
 * 3. 服务类 API（ElMessage, ElMessageBox 等）通过 auto-import 自动导入
 *
 *
 * @param app Vue应用实例
 */
export function setupElementPlus(app: App) {
  // 将服务类 API 挂载到全局属性（可选，用于 Options API）
  app.config.globalProperties.$message = ElMessage;
  app.config.globalProperties.$messageBox = ElMessageBox;
  app.config.globalProperties.$notify = ElNotification;
  app.config.globalProperties.$loading = ElLoading;

  // 注册所有 Element Plus Icon（图标体积小，全局注册方便使用）
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
  }
}
